import axios from 'axios'

const defaultComune = () => ({
  search: '',
  items: [
    { codice: 'H501', descrizione: 'ROMA', provincia: 'RM' }
  ]
})

export default {
  namespaced: true,

  state: {
    comune: defaultComune()
  },

  mutations: {
    setComune (state, value) {
      state.comune = value || defaultComune()
    }
  },

  actions: {
    async lookupComune ({ state, commit }, search) {
      try {
        if (search && state.comune.search !== search) {
          let rs = await axios.get('/api/lookups/comune', { params: { search } })
          commit('setComune', {
            search,
            items: rs.data
          })
        }
      } catch (err) {
        throw err
      }
    }
  }

}
